//advantages menu
const parentDiv = document.querySelector('.advantages__list');

parentDiv && parentDiv.addEventListener('mouseover', openAdvantagesDetails);
parentDiv && parentDiv.addEventListener('mouseout', closeAdvantagesDetails);

const findChildFor = className => {
  let childClassName = '';
  switch (className) {
    case 'advantages__item--analysis':
      childClassName = 'advantages__info--analysis';
      break;
    case 'advantages__item--manager':
      childClassName = 'advantages__info--manager';
      break;
    case 'advantages__item--all-in-one':
      childClassName = 'advantages__info--all-in-one';
      break;
    case 'advantages__item--prices':
      childClassName = 'advantages__info--prices';
      break;
    case 'advantages__item--design':
      childClassName = 'advantages__info--design';
      break;
    case 'advantages__item--implementation':
      childClassName = 'advantages__info--implementation';
      break;
    case 'advantages__item--support':
      childClassName = 'advantages__info--support';
      break;
    default:
      break;
  }
  return childClassName;
};

function openAdvantagesDetails(e) {
  let className = '';
  if (e.currentTarget && e.target.nodeName == 'LI') {
    e.preventDefault();
    className = `${e.target.id}`;
  }
  if (
    e.currentTarget &&
    (e.target.nodeName == 'P' || e.target.nodeName == 'SPAN')
  ) {
    e.preventDefault();
    className = `${e.target.dataset.id}`;
  }
  if (className) {
    const childClassName = findChildFor(className);
    const childDiv = document.getElementById(childClassName);
    if (childDiv) {
      childDiv.style.animation = 'show 1s ease-in-out both';
      childDiv.style.visibility = 'visible';
    }
  }
}

function closeAdvantagesDetails(e) {
  let className = '';
  if (e.target && e.target.nodeName == 'LI') {
    e.preventDefault();
    className = `${e.target.id}`;
  }
  if (
    e.currentTarget &&
    (e.target.nodeName == 'P' || e.target.nodeName == 'SPAN')
  ) {
    e.preventDefault();
    className = `${e.target.dataset.id}`;
  }
  if (className) {
    const childClassName = findChildFor(className);
    const childDiv = document.getElementById(childClassName);
    if (childDiv) {
      childDiv.style.animation = 'hide 1s ease-in-out both';
      childDiv.style.visibility = 'hidden';
    }
  }
}

// services li are links
const openServiceLink = (e, name) => {
  e.preventDefault();
  switch (name) {
    case 'development':
      location.href = './development.html';
      break;
    case 'design':
      location.href = './design.html';
      break;
    case 'seo':
      location.href = './seo.html';
      break;
    default:
      break;
  }
};
const development = document.querySelector('li.services__item-development');

const design = document.querySelector('li.services__item-design');

const seo = document.querySelector('li.services__item-seo');

development &&
  development.addEventListener('click', e => openServiceLink(e, 'development'));
design && design.addEventListener('click', e => openServiceLink(e, 'design'));
seo && seo.addEventListener('click', e => openServiceLink(e, 'seo'));
